import { render, staticRenderFns } from "./MePhoto.vue?vue&type=template&id=3282bb3e&scoped=true"
import script from "./MePhoto.vue?vue&type=script&lang=js"
export * from "./MePhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282bb3e",
  null
  
)

export default component.exports